var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-sheet',{staticClass:"pa-6"},_vm._l((_vm.motifs),function(motif){return _c('item-motif',{key:motif.id,attrs:{"motif":motif},on:{"deletedMotif":_vm.deletedMotif}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }